// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const UserSingle = () => {
//   // Extracting userId using regular expressions
//   const location = useLocation();
//   // const userId = location.pathname.match(/\/user\/(\d+)/);
//   const userId = location.pathname.match(/\/user\/(\d+)/)?.[1];

//   const [user, setUser] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchUser = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user/${userId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch User');
//       // }
//       const data = await response.json();
//       setUser(data);
//       localStorage.setItem("UserData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (userId) {
//       fetchUser();
//     }
//   }, [userId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">User Information</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{user?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{user?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{user?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Name: </span>
//                     <span className="itemValue">{user?.data.name}</span>
//                   </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Email: </span>
//                     <span className="itemValue">{user?.data.email}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Phone Number: </span>
//                     <span className="itemValue">{user?.data.phone_no}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Role: </span>
//                     <span className="itemValue">{user?.data.role_names}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{user?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default UserSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const UserSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.pathname.match(/\/user\/(\d+)/)?.[1];
  const [user, setUser] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchUser = async () => {
    try {
      const response = await fetch(`${serverUrl}/user/${userId}`);
      const data = await response.json();
      setUser(data);
      localStorage.setItem("UserData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUser();
    }
  }, [userId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">User Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* User Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* User Avatar */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <span className="text-2xl md:text-3xl text-purple-600">
                          {user?.data.name?.charAt(0).toUpperCase()}
                        </span>
                      </div>
                    </div>

                    {/* User Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {user?.data.name}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {user?.data.role_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Role:</span>
                            <span className="font-medium">
                              {user.data.role_names}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Contact Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {user?.data.email && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Email
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {user.data.email}
                        </p>
                      </div>
                    )}

                    {user?.data.phone_no && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Phone Number
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {user.data.phone_no}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSingle;
